// extracted by mini-css-extract-plugin
export const overlay = "popup-module--overlay--Z6R78";
export const cardWarning = "popup-module--cardWarning--1M4n_";
export const buttonClose = "popup-module--buttonClose--2XxOj";
export const linkWarning = "popup-module--linkWarning--2bRjW";